/**
 * Publication gate for the dataset.
 *
 * Every public consumer of the data imports `{ CHEESERIES, ACCOMMODATIONS }`
 * from this module, which filters out any entry flagged `verified: false`
 * in the source files. Research candidates can sit in `cheeseries.ts` /
 * `accommodations.ts` with `verified: false` and will never appear on the
 * map, in state hubs, in filters, or in region counts until they are
 * editorially confirmed and flipped to `verified: true`.
 *
 * Use `ALL_CHEESERIES` / `ALL_ACCOMMODATIONS` only for internal tooling
 * that explicitly needs to see unverified drafts (there is none today).
 */
import { CHEESERIES as _ALL_CHEESERIES } from './cheeseries';
import { ACCOMMODATIONS as _ALL_ACCOMMODATIONS } from './accommodations';

export const CHEESERIES = _ALL_CHEESERIES.filter((c) => c.verified);
export const ACCOMMODATIONS = _ALL_ACCOMMODATIONS.filter((a) => a.verified);

/** Raw arrays including unverified research drafts. */
export const ALL_CHEESERIES = _ALL_CHEESERIES;
export const ALL_ACCOMMODATIONS = _ALL_ACCOMMODATIONS;
